"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var _index = _interopRequireDefault(require("@/components/ReportNav/index.vue"));

var _LineChart = _interopRequireDefault(require("@/components/Chart/LineChart.vue"));

var _vuex = require("vuex");

var _help = _interopRequireDefault(require("@/config/help.json"));

var _report = require("@/api/report");

var _common = require("@/api/common");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'CSummary',
  components: {
    ReportNav: _index.default,
    LineChart: _LineChart.default
  },
  data: function data() {
    return {
      help: _help.default,
      summary: ['gt16', 'gt33', 'gt55'],
      pageConfig: {
        summary: {
          totalFrame: 0,
          maxCost: 0,
          minCost: 0,
          median: 0,
          average: 0,
          gt16: 0,
          gt33: 0,
          gt55: 0
        },
        chartInfo: []
      },
      pageKey: '',
      activeNames: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['reportDevice'])),
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var informRes, fileRes, i;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.projectId = _this.$route.params.projectId;
              _this.reportId = _this.$route.params.reportId;

              if (!_this.$route.meta.pageKey) {
                _context.next = 13;
                break;
              }

              _this.pageKey = _this.$route.meta.pageKey;
              _context.next = 6;
              return (0, _report.informJSONInfo)({
                inform_id: _this.reportId,
                key: _this.pageKey
              });

            case 6:
              informRes = _context.sent;
              _context.next = 9;
              return (0, _common.getFile)(informRes.data.data);

            case 9:
              fileRes = _context.sent;
              _this.pageConfig = fileRes.data;
              console.log('pageConfig', _this.pageConfig);

              for (i = 0; i < _this.pageConfig.chartInfo.length; i++) {
                _this.activeNames.push(i + '');
              }

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};
exports.default = _default;